<template>
	<div style="display: flex; flex-direction: column">
		<div class="title">线索信息</div>
		<blockList :list="list" class="list" labelWidth="100"></blockList>
	</div>
</template>
<script>
import blockList from '@/components/client/clientModule/blockSpacList.vue';
import chatSer from '@/backend/services/chat/chatSer.js';
export default {
	props: {
		summaryId: {
			type: String, //询盘id
		},
		followupName: {
			type: String,
		},
	},
	data() {
		return {
			list: {
				row1: [{ label: '线索名称', value: '' }],
				row2: [{ label: '线索来源', value: '' }],
				row3: [{ label: '跟进人', value: '' }],
				row4: [{ label: '最后跟进时间', value: '' }],
			},
		};
	},
	watch: {
		followupName: {
			handler() {
				if (this.summaryId) {
					this.getInfo();
				}
			},
			deep: true,
			immediate: true,
		},
		summaryId: {
			handler(val) {
				if (val) {
					this.getInfo();
				}
			},
			immediate: true,
		},
	},
	methods: {
		getStr(val)
		{
			switch (val) {
						case '0':
							return 'PC网站询盘';
						case '1':
							return 'APP网站询盘';
						case '2':
							return '邮件询盘';
						case '3':
							return '社交询盘';
						case '4':
							return '自建站询盘';
						case '5':
							return 'Messenger询盘';
						case '6':
							return '手动录入';
						case '7':
							return 'FB表单询盘';
						case '8':
							return 'WhatsApp询盘'
			}
		},
		async getInfo() {
			let res = await chatSer.headerDetail({
				id: this.summaryId,
				type: 1,
			});
			// const res = await chatSer.crmClueDetails({
			// 	id: this.summaryId,
			// 	// inquiryType: 5,
			// });
			// (0:PC网站询盘;1:APP网站询盘;2:邮件询盘;3:社交询盘;4:自建站询盘;5:Messenger询盘;6:手动录入;7:FB表单询盘;)")
		
            let websiteType=this.getStr(res.data.websiteType);
			this.list = {
				row1: [{ label: '线索名称', value: res.data.nickname }],
				row2: [{ label: '线索来源', value: websiteType }],
				row3: [{ label: '跟进人', value: res.data.followupName }],
				row4: [{ label: '最后跟进时间', value: res.data.recentFollowupTimeStr }],
			};
		},
	},
	components: {
		blockList,
	},
};
</script>
<style lang="scss" scoped>
.title {
	font-weight: 500;
	color: #333333;
	font-size: 16px;
	padding: 20px;
}
.list {
	margin-right: 100px;
}
</style>
